{
  "eventFile": "assets/files/JiveXML/JiveXML_336567_2327102923.xml",
  "eventType": "jivexml"
}
